module.exports = __webpack_public_path__ + "media/VideoConvert2.8f62497e.mp4";